import React from 'react';

const FetchInProgress = () => <div>Loading Screen TBD</div>;

export default FetchInProgress;
